import * as actionsTypes from "./actionTypes";
import chartActions from "./widgetsSagas/chart/actions";

const getDashboardInfo = searchFields => ({
    type: actionsTypes.GET_DASHBOARD_INFO_REQUEST,
    searchFields
});

const newDashboard = () => ({
    type: actionsTypes.CLEAN_LAYOUT,
});

const updateLayoutAndWidgetsPosition = (widgetsToUpdate, widgetsCreated, widgetsDeleted, dashboardId) => ({
    type: actionsTypes.UPDATE_LAYOUT,
    dashboardId,
    widgetsToUpdate,
    widgetsCreated,
    widgetsDeleted
});

const updateRealTimeWidgetsData = interfaceIds => ({
    type: actionsTypes.UPDATE_REAL_TIME_INTERFACES_DATA_REQUEST,
    interfaceIds
});

const createWidget = (widgetType, formData, dashboardId) => ({
    type: actionsTypes.CREATE_WIDGET_REQUEST,
    dashboardId,
    widgetType,
    formData
});

const editWidget = ( widgetToEdit, formData ) => ({
    type: actionsTypes.EDIT_WIDGET_REQUEST,
    widgetToEdit,
    formData
});

const deleteWidget = (widget) => ({
    type: actionsTypes.DELETE_WIDGET_REQUEST,
    widget
});

const duplicateWidget = (widgetId) => ({
    type: actionsTypes.DUPLICATE_WIDGET_REQUEST,
    widgetId
});

const getDashboardEntitiesTree = (rootEntityId) => ({
    type: actionsTypes.GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_REQUEST,
    rootEntityId
});

export default {
    getDashboardInfo,
    newDashboard,
    updateLayoutAndWidgetsPosition,
    updateRealTimeWidgetsData,
    deleteWidget,
    duplicateWidget,
    getDashboardEntitiesTree,
    createWidget,
    editWidget,

    loadChartData: chartActions.loadChartData
}